import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as supportActions from '../../actions/support';



function mapStateToProps(state) {
    return {
        support : state.support,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(supportActions, dispatch);
}

class SaleSupport extends React.Component {
    render() {
        return React.cloneElement(this.props.children, this.props);        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SaleSupport);



/** WEBPACK FOOTER **
 ** ./src/components/containers/SaleSupport.jsx
 **/